export default __webpack_public_path__ + "static/media/bond.2f03034f.svg";